import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "@chakra-ui/react";
const TextInfo = ({ children }) => (_jsx(Text, Object.assign({ h: "44px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "md", color: "gray.500", bg: "gray.100" }, { children: children })));
export default TextInfo;
